import * as React from 'react'
import type { VendorSnapshot } from '@/lib/api'
import { selectPremiumTemplate } from '@/components/premium'
import { useTier } from '@/root/TierContext'
import { PageSkeleton } from '@/components/ui/PageSkeleton'
import { lazyWithRetry } from '@/lib/lazyWithRetry'

// The free page is its own chunk, same as each premium template — a tenant
// only ever downloads the layout code their tier/template actually renders.
const FreeTierPage = React.lazy(
  lazyWithRetry(() => import('./FreeTierPage').then((m) => ({ default: m.FreeTierPage })), {
    reloadOnFailure: true,
  }),
)

export function MiniVendorPage({ snap }: { snap: VendorSnapshot }) {
  const { isPremium } = useTier()

  // Premium tier uses the selected template (Classic / Modern / Editorial).
  // The selector reads `snapshot.tierConfig.templateId` — defaults to Classic.
  const Page = isPremium ? selectPremiumTemplate(snap) : FreeTierPage

  // Fallback is pixel-identical to the snapshot-fetch skeleton in App.tsx, so
  // a cold load reads as one continuous skeleton while the chunk arrives.
  return (
    <React.Suspense fallback={<PageSkeleton />}>
      <Page snap={snap} />
    </React.Suspense>
  )
}
